/**
 * ToolbarPills — pill-in-tray tab / mode toggle.
 * The Sales page pattern, now standardized.
 *
 * Usage:
 *   <ToolbarPills
 *     options={[
 *       { value: 'sale',    label: 'New Sale',  icon: ShoppingCart },
 *       { value: 'history', label: 'History',   icon: Receipt,     badge: 3 },
 *     ]}
 *     value={activeTab}
 *     onChange={setActiveTab}
 *   />
 */

export function ToolbarPills({ options = [], value, onChange, className = '' }) {
  return (
    <div
      className={`inline-flex items-center p-0.5 rounded-lg ${className}`}
      style={{
        backgroundColor: '#F1F5F9',
        border: '1px solid rgba(15,23,42,0.06)',
      }}
    >
      {options.map((opt) => {
        const isActive = value === opt.value;
        const Icon = opt.icon;

        return (
          <button
            key={opt.value}
            onClick={() => onChange?.(opt.value)}
            className="relative flex items-center gap-1.5 px-3 h-8 rounded-md text-[13px] font-medium transition-colors"
            style={{
              transitionDuration: 'var(--ease-fast)',
              backgroundColor: isActive ? '#FFFFFF' : 'transparent',
              color: isActive ? 'var(--brand-primary)' : 'var(--text-secondary)',
              boxShadow: isActive ? '0 1px 2px rgba(15,23,42,0.06)' : 'none',
              border: isActive ? '1px solid rgba(15,23,42,0.08)' : '1px solid transparent',
            }}
          >
            {isActive && (
              <span
                className="absolute left-0 top-1.5 bottom-1.5 w-[2px] rounded-r"
                style={{ backgroundColor: 'var(--brand-primary)' }}
              />
            )}
            {Icon && <Icon size={13} strokeWidth={1.75} />}
            <span>{opt.label}</span>
            {opt.badge > 0 && (
              <span
                className="ml-0.5 inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full text-[10px] font-semibold"
                style={{ backgroundColor: 'var(--brand-primary)', color: '#FFFFFF' }}
              >
                {opt.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
